import { usePanelNavigate } from '../hooks/usePanelNavigate';

const isRouteKey = (key) => typeof key === 'string' && key.startsWith('/');

export function SidebarMenuLink({ to, children }) {
  const navigate = usePanelNavigate();

  return (
    <a
      href={to}
      className="!text-inherit no-underline"
      onClick={(e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        navigate(to);
      }}
    >
      {children}
    </a>
  );
}

export function attachPanelMenuLinks(items, LinkComponent = SidebarMenuLink) {
  if (!items?.length) return items;

  return items.map((item) => {
    if (!item || item.type === 'divider') return item;

    const withChildren = item.children?.length
      ? { ...item, children: attachPanelMenuLinks(item.children, LinkComponent) }
      : item;

    if (!isRouteKey(item.key)) return withChildren;

    const label = item.label;
    return {
      ...withChildren,
      label: <LinkComponent to={item.key}>{label}</LinkComponent>,
    };
  });
}
